export const Loader = ({ color = "text-white" }: { color?: string }) => (
  <div className="flex items-center justify-center" role="status">
    <svg
      className={`mr-3 -ml-1 size-5 animate-spin ${color}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </div>
);

export const SkeletonLoader = () => {
  return (
    <div role="status" className="max-w-sm animate-pulse">
      <div className="h-40 bg-gray-100 dark:bg-gray-300 w-full mb-4"></div>
      <div className="h-2.5 bg-gray-100 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
      <div className="h-2 bg-gray-100 rounded-full dark:bg-gray-300 max-w-[360px] mb-2.5"></div>
      <div className="h-2 bg-gray-100 rounded-full dark:bg-gray-300 mb-2.5"></div>
      <div className="h-2 bg-gray-100 rounded-full dark:bg-gray-300 max-w-[330px] mb-2.5"></div>
      <div className="h-2 bg-gray-100 rounded-full dark:bg-gray-300 max-w-[330px] mb-2.5"></div>

      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const StatLoader = () => {
  return (
    <div role="status" className="max-w-sm animate-pulse">
      <div className="h-8 bg-gray-100 dark:bg-gray-300 w-48 rounded mb-4"></div>
      <div className="h-5 bg-gray-100 rounded-md dark:bg-gray-300 w-12 mb-4"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const TableSkeleton = () => (
  <div className="flex items-center justify-between p-4 bg-white border-b border-slate-100 animate-pulse w-full">
    <div className="flex-1 space-y-2.5">
      <div className="h-4 bg-slate-200 rounded w-1/3"></div>
      <div className="h-3 bg-slate-200 rounded w-1/2"></div>
    </div>
    <div className="w-48 flex items-center justify-end gap-2 shrink-0 hidden md:flex">
      <div className="h-8 bg-slate-200 rounded-lg w-24"></div>
      <div className="h-8 bg-slate-200 rounded-lg w-28"></div>
    </div>
  </div>
);
